import React from 'react';
import PropTypes from 'prop-types';

import './Download.css';
import DownloadComponent from './DownloadComponent';

function Download({ downloadData, divHeight, viewportWidth }) {
  return (
    <div
      className={
        viewportWidth > 768
          ? 'download-button-container'
          : 'download-button-container-mobil'
      }
      style={viewportWidth > 768 ? { height: divHeight } : null}
    >

      {downloadData.map((value) => (
        <DownloadComponent value={value} />
      ))}
    </div>
  );
}

export default Download;

Download.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  downloadData: PropTypes.any.isRequired,
  divHeight: PropTypes.number.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
